<template>
    <div 
        data-widget="image"
        class="relative"
    >
        <NuxtLink
            v-if="(pID && widget?.media.images.length === 1 && widget?.meta.extern_link) || (source?.length === 1 && widget?.meta.extern_link)" 
            :to="hyperlink"
            :target="hyperlinkExtern ? '_blank' : '_self'"
        >
            <MediaElement
                :src="pID ? widget?.media.images[0].path : source[0].path"
                :alt="pID && widget?.media.images[0].description"
                :classes="props.classes"
                @loaded="emit('loaded')"
            />
        </NuxtLink>

        <MediaElement
            v-if="(pID && widget?.media.images.length === 1 && !widget?.meta.extern_link) || (source?.length === 1 && !widget?.meta.extern_link)"
            :src="pID ? widget?.media.images[0].path : source[0].path"
            :alt="pID && widget?.media.images[0].description"
            :classes="props.classes"
            @loaded="emit('loaded')"
        />

        <div
            v-if="pID && widget?.media.images.length > 1 && widget?.meta.switch"
            class="gallery-container"
            :class="widget.meta.swiper_columns == 1 ? 'grid-default' : `grid-default--${widget.meta.swiper_columns}`"
        >
            <div 
                v-for="image in widget?.media.images" 
                :key="image.path"  
                class="image-container"
            >
                <MediaElement
                    :src="image.path"
                    :alt="image.description"
                    :classes="props.classes"
                    @loaded="emit('loaded')"
                />
            </div>
        </div>

        <SwiperGallery 
            v-if="(pID && widget?.media.images.length > 1 && !widget?.meta.switch) || (source?.length > 1 && thumbnail)"
            :images="source"
            :thumbnail="thumbnail"
            :pID="pID"
            @loaded="emit('loaded')"
        />
    </div>
</template>

<script setup lang="ts">
    import { useRequestStore } from '@/stores/requests'

    const props = defineProps<{
        pID?: number
        classes?: any
        source?: any
        alt?: string
        thumbnail?: boolean
    }>();

    const requestStore = useRequestStore();
    const { pageContent, pageID } = storeToRefs(requestStore);

    const { locale } = useI18n()

    const emit = defineEmits(['loaded']);

    const hyperlink = ref('')
    const hyperlinkExtern = ref(false)

    const widget = computed(() => {
        const widgets = pageContent.value[pageID.value]?.pagecontent.widgets
        const widgetContent = widgets?.find((widget: any) => widget.meta.cID === props.pID)

        const regex = /https?:\/\/(?:www\.)?walbert-schmitz\.de\/(?:de|en)/

        if (widgetContent?.meta?.extern_link !== undefined && widgetContent?.meta?.extern_link_target !== undefined) {
            if (regex.test(widgetContent.meta?.extern_link_target)) {
                hyperlink.value = widgetContent.meta?.extern_link_target?.replace(regex, `/${locale.value}`)
            } else if (!regex.test(widgetContent.meta?.extern_link_target)) {
                hyperlinkExtern.value = true
                hyperlink.value = widgetContent.meta?.extern_link_target
            }
        }

        return widgetContent
    });
</script>